import { render, staticRenderFns } from "./FxNdf.vue?vue&type=template&id=41ba5f99"
import script from "./FxNdf.vue?vue&type=script&lang=js"
export * from "./FxNdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports